/**
 * Tiers that stay listed but nobody can run, BYOK included (Rahul, 30 Oct 2026: too expensive on the
 * house keys). Opening one again is a change to this list.
 */
const COMING_SOON_TIERS = ['ultramax'];
const COMING_SOON_LABEL_TEXT = 'Coming soon';
const ULTRAMAX_IS_COMING_SOON = `UltraMax is ${COMING_SOON_LABEL_TEXT.toLowerCase()}`;
export const COMING_SOON_LABEL = COMING_SOON_LABEL_TEXT;
export const TIER_COMING_SOON = 'TIER_COMING_SOON';
export const TIER_COMING_SOON_MESSAGE = `${ULTRAMAX_IS_COMING_SOON}. Use basic or pro.`;
export const TIER_COMING_SOON_BODY = { error: TIER_COMING_SOON_MESSAGE, code: TIER_COMING_SOON };
/** The one line a video stored on a closed tier reads when its next turn runs on Pro. */
export const TIER_MOVED_TO_PRO_NOTICE = `${ULTRAMAX_IS_COMING_SOON}, so this video continues on Pro.`;
export function isTierAvailable(tier) {
    return !COMING_SOON_TIERS.includes(tier);
}
/** The tier a stored or remembered value runs on: itself, or Pro when its own tier is closed. */
export function availableTier(tier) {
    return isTierAvailable(tier) ? tier : 'pro';
}
